<template lang="pug">
    //- nuxt-link's event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-nuxt-link.
    //- We are still currently using vue-router 3 but the compiler is letting us know the event prop is being deprecated
    nuxt-link(
        :to="linkBuilder(urlData)"
        :event="event"
        @touchstart.native="handleTouch"
        @click.native="navigate"
    )
        slot
</template>

<script>
import { linkBuilders } from '@/helpers/mixins'

export default {
    mixins: [linkBuilders],
    props: {
        urlData: {
            type: Object,
            required: true,
        },
        hasMenu: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            disableClick: false,
        }
    },
    computed: {
        event() {
            return this.hasMenu ? '' : 'click'
        },
    },
    methods: {
        handleTouch() {
            if (!this.hasMenu) return
            this.disableClick = true
        },
        navigate() {
            if (!this.hasMenu || this.disableClick) return
            this.$push.to(this.linkBuilder(this.urlData))
        },
    },
}
</script>
